import React, { memo, useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'

import Modalize from '../../../../components/Modalize'
import { useTheme } from '../../../../theming/ThemeProvider'
import styles from './styles'
import LoadDetails from '../../../../components/LoadDetails'
import { getLoadStatusData } from '../../../../tools/dataParse'
import { View, Keyboard } from 'react-native'

const modalTopOffset = 115

const LoadCard = (props) => {
  const { load, selected, module } = props

  const [open, setOpen] = useState(false)
  const [disableScroll, setDisableScroll] = useState(true)
  const [cardMoved, setCardMoved] = useState(false)
  const [status] = useState(getLoadStatusData(module, load))
  const { theme } = useTheme()

  useEffect(() => {
    if (!selected) setOpen(false)
  }, [selected])

  const onPositionChange = useCallback((position) => {
    setDisableScroll(position === 'initial')
  }, [])

  const onClosed = useCallback(() => {
    setOpen(false)
    if (!cardMoved) {
      setCardMoved(true)
    }
  }, [cardMoved])

  useEffect(() => {
    const keyboardWillShowListener = Keyboard.addListener(
      'keyboardWillShow',
      () => {
        if (selected && !open) {
          setOpen(true)
        }
      }
    )

    return () => {
      keyboardWillShowListener.remove()
    }
  }, [selected, open])

  return (
    <Modalize
      open={open}
      handleModal={setOpen}
      alwaysOpen={cardMoved ? 140 : 350}
      modalTopOffset={modalTopOffset}
      overlayStyle={styles.modalizeOverlay}
      autoHandleClose
      modalStyle={{
        borderTopWidth: status ? 7 : 0,
        borderColor: status ? theme[status.color] : null,
        backgroundColor: theme.WHITE
      }}
      customRenderer={(
        <View>
          <LoadDetails
            load={load}
            containerStyle={{ marginVertical: 30 }}
            module={module}
            disableScroll={disableScroll}
          />
        </View>
      )}
      onPositionChange={onPositionChange}
      onClosed={onClosed}
    />
  )
}

LoadCard.propTypes = {
  load: PropTypes.object,
  selected: PropTypes.bool,
  module: PropTypes.string
}

export default memo(LoadCard)
